import { toast } from "react-toastify";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { createMRTColumnHelper } from "material-react-table";
// import ToastComponent from "../../../components/customTable/ToastComponent";
import CustomTable from "../../components/customTable/CustomTable";
import { useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../../utils/axiosInstance";

export default function SipTables({ sliceResponse, stateLoading }) {
  console.log(sliceResponse, "helooooooooooooooo");
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleView = async (rowData) => {
    setOpenDialog(true);
    const responses = await axiosInstance.get(
      `/getEmandate/${rowData}`,
      //   {
      //   headers,
      // }
    );
    // const responses = await axios.get(`${baseUrl}/getEmandate/${rowData}`, {
    //   headers,
    // });

    // console.log("responses++++++++++++++++++++++", responses.data);
    setSelectedRow(responses.data.data);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("customerRefNo", {
      header: "Customer Name",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo?._id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo?._id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo?.name}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("Phone", {
      header: "Phone",
      size: 20,
      Cell: (cell) => cell.row.original?.customerRefNo?.phone,
    }),
    columnHelper.accessor("metal_type", {
      header: "Metal Type",
      size: 20,
      Cell: (cell) => cell.row.original?.metal_type,
    }),
    columnHelper.accessor("frequency", {
      header: "Frequency",
      size: 20,
      Cell: (cell) => cell.row.original?.frequency,
    }),
    columnHelper.accessor("amount", {
      header: "Amount",
      size: 20,
      Cell: (cell) => "₹" + cell.row.original?.amount,
    }),
    columnHelper.accessor("subReferenceId", {
      header: "Sub Reference Id",
      size: 20,
      Cell: (cell) => cell.row.original?.subReferenceId || "N/A",
    }),
    columnHelper.accessor("subscription_id", {
      header: "Subscription Id",
      size: 20,
      Cell: (cell) => cell.row.original?.subscription_id || "N/A",
    }),

    columnHelper.accessor("customerRefNo", {
      header: "Partner Username",
      size: 20,
      Cell: (cell) => cell.row.original?.customerRefNo?.partner_username,
    }),
    columnHelper.accessor("day_of_month", {
      header: "Day of Month",
      size: 20,
      Cell: (cell) => cell.row.original?.day_of_month,
    }),

    columnHelper.accessor("platform", {
      header: "Platform",
      size: 20,
      Cell: (cell) => cell.row.original?.platform || "Mobile",
    }),

    // columnHelper.accessor("order_id", {
    //     header: "Order ID",
    //     size: 30,
    //     Cell: (cell) => (
    //         <div style={{ textAlign: "center" }}>{cell.row.original?.order_id}</div>
    //     ),
    // }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => cell.row?.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("payment_link", {
      header: "Payment Link",
      size: 50,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.payment_link);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.payment_link}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 20,
      Cell: (cell) => cell.row.original?.status,
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => cell.row?.original?.updatedAt?.split("T")[0],
    }),
    columnHelper.accessor("Actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const rowData = cell.row.original?.subReferenceId;
        return (
          <Tooltip title="View Details">
            <IconButton onClick={() => handleView(rowData)} color="primary">
              <VisibilityOutlinedIcon />
            </IconButton>
          </Tooltip>
        );
      },
    }),
  ];

  const getValue = (value) => {
    return value !== null && value !== undefined && value !== ""
      ? value
      : "---";
  };

  const getCurrencyValue = (value) => {
    return value !== null && value !== undefined && value !== ""
      ? `₹${value}`
      : "---";
  };

  const getDateValue = (value) => {
    return value ? new Date(value).toLocaleDateString() : "---";
  };

  return (
    <>
      {/* */}

      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="Sip"
      />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <strong style={{ fontSize: 18 }}>SIP Details</strong>
          <Tooltip title="Close">
            <IconButton
              sx={{ float: "right" }}
              onClick={() => {
                setOpenDialog(false);
              }}
              aria-label="delete"
              size="small"
            >
              <CloseIcon
                fontSize="inherit"
                color="error"
                sx={{ color: "red" }}
              />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent dividers>
          {selectedRow ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Row 1 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Subscription Id:</strong>{" "}
                    {getValue(selectedRow.subscriptionId)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Sub Reference Id:</strong>{" "}
                    {getValue(selectedRow.subReferenceId)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Plan Id:</strong> {getValue(selectedRow.planId)}
                  </Typography>
                </Box>
              </Box>
              {/* Row 2 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Plan Name:</strong> {getValue(selectedRow.planName)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Max Cycles:</strong>{" "}
                    {getValue(selectedRow.maxCycles)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Type:</strong> {getValue(selectedRow.type)}
                  </Typography>
                </Box>
              </Box>

              {/* Row 3 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Day of Month:</strong>{" "}
                    {selectedRow.scheduledOn
                      ? new Date(selectedRow.scheduledOn).getDate()
                      : "---"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>First Charge Date:</strong>{" "}
                    {getDateValue(selectedRow.firstChargeDate)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Expiry Date:</strong>{" "}
                    {getDateValue(selectedRow.expiryDate)}
                  </Typography>
                </Box>
              </Box>

              {/* Row 4 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Interval:</strong> {getValue(selectedRow.intervals)}{" "}
                    {getValue(selectedRow.intervalType)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Recurring Amount:</strong>{" "}
                    {getCurrencyValue(selectedRow.recurringAmount)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Max Amount:</strong>{" "}
                    {getCurrencyValue(selectedRow.maxAmount)}
                  </Typography>
                </Box>
              </Box>

              {/* Row 5 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>UPI ID:</strong> {getValue(selectedRow.upiId)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>UMN:</strong> {getValue(selectedRow.umn)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Auth Flow:</strong> {getValue(selectedRow.authFlow)}
                  </Typography>
                </Box>
              </Box>

              {/* Row 6 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Mode:</strong> {getValue(selectedRow.mode)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Status:</strong> {getValue(selectedRow.status)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>TPV Enabled:</strong>{" "}
                    {selectedRow.tpvEnabled ? "Yes" : "No"}
                  </Typography>
                </Box>
              </Box>

              {/* Row 7 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Auth Link:</strong>{" "}
                    {selectedRow.authLink ? (
                      <a
                        href={selectedRow.authLink}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          color: "#1976d2",
                          textDecoration: "underline",
                        }}
                      >
                        Link
                      </a>
                    ) : (
                      "---"
                    )}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Added On:</strong>{" "}
                    {getDateValue(selectedRow.addedOn)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Current Cycle:</strong>{" "}
                    {getValue(selectedRow.currentCycle)}
                  </Typography>
                </Box>
              </Box>

              {/* Row 8 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Customer Name:</strong>{" "}
                    {getValue(selectedRow.customerName)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Email:</strong>{" "}
                    {getValue(selectedRow.customerEmail)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Phone:</strong>{" "}
                    {getValue(selectedRow?.customerPhone)}
                  </Typography>
                </Box>
              </Box>

              {/* Row 9 */}
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: 1,
                  borderRadius: 1,
                }}
              >
                Account Details
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Account No:</strong>{" "}
                    {getValue(selectedRow.payerAccountDetails?.accountNumber)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>IFSC:</strong>{" "}
                    {getValue(selectedRow.payerAccountDetails?.ifsc)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Bank Name:</strong>{" "}
                    {getValue(selectedRow.payerAccountDetails?.bankName)}
                  </Typography>
                </Box>
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: 1,
                  borderRadius: 1,
                }}
              >
                Partner Details
              </Typography>

              {/* Row 10 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Partner Name:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.name)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Email:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.email)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Mobile:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.mobileNo)}
                  </Typography>
                </Box>
              </Box>

              {/* Row 11 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>PAN No:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.panNo)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Aadhar No:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.aadharNo)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>DOB:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.dob)}
                  </Typography>
                </Box>
              </Box>

              {/* Row 12 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Address:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.Address)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>City :</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.city)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Commission %:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.commission_per)}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>EntityType:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.EntityType)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>state :</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.state)}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>MMTC Commission %:</strong>{" "}
                    {getValue(selectedRow.partnerDetails?.mmtc_commission_per)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                  backgroundColor: "background.default",
                }}
              >
                <CircularProgress size={80} sx={{ color: "#1976d2" }} />
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
